import store from 'index.js'
import {
  startGame,
  stopGame,
  setValuesToInitial,
  setAnimation,
  setInstantBet
} from './gameLogic.js'
import {
  createUI
} from './gameUI.js'
import { appendMyBetsRoulette, setBetWinAmt, setDemoMyBets, setRouletteRoundEnd } from '../../../slice-thunk/rouletteGame.slice.js'
import { dequeueCreditWalletWaitQueue, updateDemoWalletBalance, updateUserWallet } from 'redux-store/redux/slices/auth.slice.js'

export function gameManager () {
  createUI()
}

export function resetGame () {
  setValuesToInitial()
}

export function start () {
  resetGame()
  startGame()
}

export function stop (stopNumber = 5) {
  stopGame(stopNumber)
}

export function toggleInstantBet (bool) {
  setInstantBet(bool)
}

export function toggleAnimation (bool) {
  setAnimation(bool)
}

export function ballStoppedAtTarget () {
  const betWinAmt = store.getState()?.rouletteGame?.betWinAmt
  const demoMode = store.getState()?.auth?.demoMode
  setTimeout(() => store.dispatch(setRouletteRoundEnd()), 200)
  setTimeout(() => {
    if (demoMode) store.dispatch(setDemoMyBets())
    else store.dispatch(appendMyBetsRoulette())
  }, 200)
  if (demoMode && betWinAmt) {
    store.dispatch(updateDemoWalletBalance(betWinAmt.balance))
  } else {
    setTimeout(() => store.dispatch(dequeueCreditWalletWaitQueue()), 300)
  }
  store.dispatch(setBetWinAmt(null))
  // setTimeout(() => store.dispatch(dequeueCreditWalletWaitQueue()), 300)
  // console.log("==========Ball Stopped================");
}
